class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    if (facetForm) {
      if (facetForm.id === "FacetSortForm" || facetForm.id === "FacetSortDrawerForm") {
        facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
        facetForm.addEventListener("change", this.debouncedOnSubmit.bind(this));
      }
      facetForm.addEventListener("submit", (event) => {
        event.preventDefault();
        this.onApplyFilters(event);
      });
    }

    this.addEventListener("click", (event) => {
      const applyBtn = event.target.closest(".facets__apply-btn");
      if (applyBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.onApplyFilters(event);
      }
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static closeDrawer(event) {
    const menuDrawer = document.querySelector(".mobile-facets__wrapper");
    if (menuDrawer && typeof menuDrawer.closeMenuDrawer === "function") {
      const summary = menuDrawer.querySelector("summary");
      menuDrawer.closeMenuDrawer(event, summary);
    } else {
      const disclosure = document.querySelector(".mobile-facets__disclosure[open]");
      if (disclosure) {
        disclosure.removeAttribute("open");
        disclosure.classList.remove("menu-opening");
        disclosure.querySelectorAll("details").forEach((el) => {
          el.removeAttribute("open");
          el.classList.remove("menu-opening");
        });
        disclosure.querySelectorAll(".submenu-open").forEach((el) => {
          el.classList.remove("submenu-open");
        });
        document.body.classList.remove("overflow-hidden-mobile");
      }
    }
  }

  onApplyFilters(event) {
    const target = event ? (event.target || event.srcElement) : null;
    const currentForm = (target && target.closest("form")) || this.querySelector("form") || document.getElementById("FacetFiltersFormMobile") || document.getElementById("FacetFiltersForm");
    FacetFiltersForm.closeDrawer(event);
    this.onSubmitHandler(event, currentForm);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");

    const gridContainer = document.getElementById("ProductGridContainer");
    if (gridContainer && gridContainer.querySelector(".collection")) {
      gridContainer.querySelector(".collection").classList.add("loading");
    }

    if (countContainer) {
      countContainer.classList.add("loading");
      const parent = countContainer.closest(".product-count__text");
      if (parent) parent.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
      const parent = countContainerDesktop.closest(".product-count__text");
      if (parent) parent.classList.add("loading");
    }
    document.querySelectorAll(".ProductCountDesktop").forEach((el) => {
      el.classList.add("loading");
      const parent = el.closest(".product-count__text");
      if (parent) parent.classList.add("loading");
    });

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData && FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...(FacetFiltersForm.filterData || []),
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof InitCustomFunctions === 'function') InitCustomFunctions();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof InitCustomFunctions === 'function') InitCustomFunctions();
  }

  static renderProductGridContainer(html) {
    const gridContainer = document.getElementById("ProductGridContainer");
    if (gridContainer) {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      const newGrid = parsedHTML.getElementById("ProductGridContainer");
      if (newGrid) gridContainer.innerHTML = newGrid.innerHTML;
    }
  }

  static renderProductCount(html) {
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");

    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const countElementDesktop = parsedHTML.getElementById("ProductCountDesktop");
    const countElement = parsedHTML.getElementById("ProductCount");

    if (containerDesktop) {
      const content = countElementDesktop ? countElementDesktop.innerHTML : (countElement ? countElement.innerHTML : "");
      if (content) containerDesktop.innerHTML = content;
      containerDesktop.classList.remove("loading");
      const parentText = containerDesktop.closest(".product-count__text");
      if (parentText) parentText.classList.remove("loading");
    }

    if (container) {
      const content = countElement ? countElement.innerHTML : (countElementDesktop ? countElementDesktop.innerHTML : "");
      if (content) container.innerHTML = content;
      container.classList.remove("loading");
      const parentText = container.closest(".product-count__text");
      if (parentText) parentText.classList.remove("loading");
    }

    const classContainers = document.querySelectorAll(".ProductCountDesktop");
    const classCountElement = parsedHTML.querySelector(".ProductCountDesktop");
    if (classContainers.length > 0 && classCountElement) {
      classContainers.forEach((el) => {
        el.innerHTML = classCountElement.innerHTML;
        el.classList.remove("loading");
        const parentText = el.closest(".product-count__text");
        if (parentText) parentText.classList.remove("loading");
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const isApply = event && (
      (event.target && event.target.closest && event.target.closest(".facets__apply-btn")) ||
      event.type === "submit"
    );
    const isFacetRemove = event && event.target && event.target.closest && (
      event.target.closest("facet-remove, .mobile-facets__clear, .facets__reset") !== null
    );
    const matchesIndex = (element) => {
      if (isApply || isFacetRemove) return false;
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetEl = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (targetEl) targetEl.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target.closest(".js-filter"))
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const targetActiveEl = document.querySelector(selector);
      if (targetActiveEl) targetActiveEl.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
    ];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      if (!sourceEl) return;
      const targetMobEl = document.querySelector(selector);
      if (targetMobEl) targetMobEl.innerHTML = sourceEl.innerHTML;
    });

    // Update all sorting containers across the page
    const sourceSortingElements = html.querySelectorAll(".sorting");
    const targetSortingElements = document.querySelectorAll(".sorting");
    if (sourceSortingElements.length > 0 && targetSortingElements.length > 0) {
      targetSortingElements.forEach((targetEl, idx) => {
        const sourceEl = sourceSortingElements[idx] || sourceSortingElements[0];
        if (sourceEl) {
          targetEl.innerHTML = sourceEl.innerHTML;
        }
      });
    }

    // Sync sort dropdown and radio states across UI
    const activeSortBy = new URLSearchParams(FacetFiltersForm.searchParamsPrev || window.location.search.slice(1)).get("sort_by");
    if (activeSortBy) {
      document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
        radio.checked = radio.value === activeSortBy;
      });
      document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
        select.value = activeSortBy;
      });
    }

    const mobForm = document.getElementById("FacetFiltersFormMobile");
    if (mobForm && mobForm.closest("menu-drawer")) {
      mobForm.closest("menu-drawer").bindEvents();
    }

    const mobDisclosure = document.querySelector(".mobile-facets__disclosure");
    if (mobDisclosure) mobDisclosure.classList.add("test");
  }

  static renderCounts(source, target) {
    if (!target || !source) return;
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      targetElementAccessibility.outerHTML = sourceElementAccessibility.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams ? "?".concat(searchParams) : ""}`,
    );
  }

  static getSections() {
    const gridEl = document.getElementById("product-grid");
    return [
      {
        section: gridEl ? gridEl.dataset.id : "",
      },
    ];
  }

  createSearchParams(form) {
    if (!form) return "";
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value !== undefined && value !== null && value.toString().trim() !== "") {
        params.append(key, value);
      }
    }
    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    if (typeof InitCustomFunctions === 'function') InitCustomFunctions();
  }

  onSubmitHandler(event, formOverride = null) {
    if (event) event.preventDefault();

    const target = event ? (event.target || event.srcElement) : null;
    const isApplyButton = target && target.closest && target.closest(".facets__apply-btn") !== null;
    const isSortInput =
      !isApplyButton &&
      target &&
      (target.name === "sort_by" ||
       target.classList.contains("dt-sort-list") ||
       target.closest(".sorting, .facet-filters__sort, .mobile-facets__sort, #FacetSortForm, #FacetSortDrawerForm") !== null) &&
      !target.closest("#FacetFiltersFormMobile, #FacetFiltersForm");

    // Current query parameters from URL or previous state
    const currentQueryString = window.location.search.slice(1) || FacetFiltersForm.searchParamsPrev || "";
    const currentUrlParams = new URLSearchParams(currentQueryString);

    if (isSortInput) {
      // --- SORT BY CHANGED: Preserve all active filters and update only sort_by ---
      const newSortBy = target ? target.value : "";
      const searchParams = new URLSearchParams();

      // 1. Preserve all active filter parameters, search terms, etc. from current URL
      currentUrlParams.forEach((val, key) => {
        if (key !== "sort_by" && key !== "page" && val !== undefined && val !== null && val.toString().trim() !== "") {
          searchParams.append(key, val);
        }
      });

      // 2. Also check active filter forms in DOM to ensure no selected filters were missed
      const filterForms = document.querySelectorAll(
        "#FacetFiltersForm, #FacetFiltersFormMobile"
      );
      filterForms.forEach((form) => {
        const formData = new FormData(form);
        for (const [key, value] of formData.entries()) {
          if (
            key !== "sort_by" &&
            key !== "page" &&
            value !== undefined &&
            value !== null &&
            value.toString().trim() !== ""
          ) {
            if (!searchParams.getAll(key).includes(value)) {
              searchParams.append(key, value);
            }
          }
        }
      });

      // 3. Set the new sort_by parameter
      if (newSortBy && newSortBy.trim() !== "") {
        searchParams.set("sort_by", newSortBy);
      } else {
        searchParams.delete("sort_by");
      }

      // Preserve type=product on search
      if (!searchParams.has("type") && (currentUrlParams.has("q") || searchParams.has("q") || window.location.pathname.includes("/search"))) {
        searchParams.set("type", "product");
      }

      this.onSubmitForm(searchParams.toString(), event);
    } else {
      // --- FILTER CHANGED: Collect updated filters and preserve active sort_by ---
      const currentForm = formOverride || (target && target.closest ? target.closest("form") : null) || document.getElementById("FacetFiltersFormMobile") || document.getElementById("FacetFiltersForm");
      const isMobile = currentForm && currentForm.id === "FacetFiltersFormMobile";

      const individualFilter = target && target.closest ? target.closest(".js-filter") : null;
      const searchParams = new URLSearchParams();

      if (individualFilter) {
        // --- INDIVIDUAL FILTER APPLY: Apply only this filter's selections, preserve all other active filters ---
        const filterParamNames = new Set();
        individualFilter.querySelectorAll("input[name], select[name]").forEach((input) => {
          if (input.name && input.name !== "page") {
            filterParamNames.add(input.name);
          }
        });

        // 1. Copy all active parameters from current URL except the ones for this individual filter
        currentUrlParams.forEach((value, key) => {
          if (
            !filterParamNames.has(key) &&
            key !== "page" &&
            value !== undefined &&
            value !== null &&
            value.toString().trim() !== ""
          ) {
            searchParams.append(key, value);
          }
        });

        // 2. Add the selections from this individual filter
        individualFilter.querySelectorAll("input, select").forEach((input) => {
          if (!input.name || input.disabled || input.name === "page") return;
          if ((input.type === "checkbox" || input.type === "radio") && !input.checked) return;
          const val = input.value;
          if (val !== undefined && val !== null && val.toString().trim() !== "") {
            if (!searchParams.getAll(input.name).includes(val)) {
              searchParams.append(input.name, val);
            }
          }
        });
      } else {
        // --- GLOBAL APPLY: Collect all filters from forms ---
        const sortFilterForms = document.querySelectorAll("facet-filters-form form");

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (
              form.id === "FacetSortForm" ||
              form.id === "FacetFiltersForm" ||
              form.id === "FacetSortDrawerForm"
            ) {
              form.querySelectorAll(".no-js, .no-js-inline").forEach((el) => el.remove());
              const formData = new FormData(form);
              for (const [key, value] of formData.entries()) {
                if (
                  key !== "page" &&
                  value !== undefined &&
                  value !== null &&
                  value.toString().trim() !== ""
                ) {
                  if (!searchParams.getAll(key).includes(value)) {
                    searchParams.append(key, value);
                  }
                }
              }
            }
          } else if (form.id === "FacetFiltersFormMobile") {
            form.querySelectorAll(".no-js, .no-js-inline").forEach((el) => el.remove());
            const formData = new FormData(form);
            for (const [key, value] of formData.entries()) {
              if (
                key !== "page" &&
                value !== undefined &&
                value !== null &&
                value.toString().trim() !== ""
              ) {
                if (!searchParams.getAll(key).includes(value)) {
                  searchParams.append(key, value);
                }
              }
            }
          }
        });
      }

      // Preserve search parameters (q, type, options[prefix]) if present
      if (currentUrlParams.has("q") && !searchParams.has("q")) {
        searchParams.set("q", currentUrlParams.get("q"));
      }
      if (currentUrlParams.has("options[prefix]") && !searchParams.has("options[prefix]")) {
        searchParams.set("options[prefix]", currentUrlParams.get("options[prefix]"));
      }
      if (currentUrlParams.has("type")) {
        searchParams.set("type", currentUrlParams.get("type"));
      } else if (searchParams.has("q") || currentUrlParams.has("q") || window.location.pathname.includes("/search")) {
        searchParams.set("type", "product");
      }

      // Preserve active sort_by if not present in the forms
      if (!searchParams.has("sort_by")) {
        const activeSortRadio = document.querySelector('input[name="sort_by"]:checked');
        const activeSortSelect = document.querySelector('select[name="sort_by"]');
        const currentSortBy =
          (activeSortRadio ? activeSortRadio.value : null) ||
          (activeSortSelect ? activeSortSelect.value : null) ||
          currentUrlParams.get("sort_by");

        if (currentSortBy && currentSortBy.trim() !== "") {
          searchParams.set("sort_by", currentSortBy);
        }
      }

      // Reset pagination upon filter change
      searchParams.delete("page");

      this.onSubmitForm(searchParams.toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1,
        );
    const params = new URLSearchParams(url);

    // Current query parameters from URL or previous state
    const currentQueryString = window.location.search.slice(1) || FacetFiltersForm.searchParamsPrev || "";
    const currentUrlParams = new URLSearchParams(currentQueryString);

    // Preserve sort_by if not explicitly set in the remove URL
    if (!params.has("sort_by")) {
      const activeSortRadio = document.querySelector('input[name="sort_by"]:checked');
      const activeSortSelect = document.querySelector('select[name="sort_by"]');
      const currentSortBy =
        (activeSortRadio ? activeSortRadio.value : null) ||
        (activeSortSelect ? activeSortSelect.value : null) ||
        currentUrlParams.get("sort_by");

      if (currentSortBy && currentSortBy.trim() !== "") {
        params.set("sort_by", currentSortBy);
      }
    }

    // Preserve search parameters (q, options[prefix]) if present
    if (currentUrlParams.has("q") && !params.has("q")) {
      params.set("q", currentUrlParams.get("q"));
    }
    if (currentUrlParams.has("options[prefix]") && !params.has("options[prefix]")) {
      params.set("options[prefix]", currentUrlParams.get("options[prefix]"));
    }

    // Preserve type=product on search
    if ((params.has("q") || currentUrlParams.has("q") || window.location.pathname.includes("/search")) && !params.has("type")) {
      params.set("type", "product");
    }

    // Reset pagination to page 1 upon filter change
    params.delete("page");

    FacetFiltersForm.renderPage(params.toString(), event);
    if (typeof InitCustomFunctions === 'function') InitCustomFunctions();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener("click", (event) => {
  const applyBtn = event.target.closest(".facets__apply-btn");
  if (applyBtn) {
    event.preventDefault();
    const formElement = applyBtn.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    if (formElement && typeof formElement.onApplyFilters === "function") {
      formElement.onApplyFilters(event);
    } else {
      FacetFiltersForm.closeDrawer(event);
      const targetForm = applyBtn.closest("form") || document.getElementById("FacetFiltersFormMobile") || document.getElementById("FacetFiltersForm");
      if (formElement && typeof formElement.onSubmitHandler === "function") {
        formElement.onSubmitHandler(event, targetForm);
      }
    }
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    event.currentTarget.dispatchEvent(new Event("input", { bubbles: true }));
    InitCustomFunctions();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const filterContainer = this.closest(".js-filter");
    if (filterContainer) {
      filterContainer.querySelectorAll("input[type='checkbox']:checked").forEach((cb) => {
        cb.checked = false;
      });
      filterContainer.querySelectorAll("input[type='number'], input[type='text']").forEach((input) => {
        input.value = "";
      });
    }
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class SidebarCarousel extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiper = new Swiper(this.querySelector("#swiper-sidebar-carousel"), {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector("#swiper-sidebar-next"),
        prevEl: this.querySelector("#swiper-sidebar-prev"),
      },
    });
  }
}

customElements.define("sidebar-carousel", SidebarCarousel);

document.addEventListener("DOMContentLoaded", function () {
  // Function to remove class if window size is less than 768 pixels
  function removeClassIfLessThan768() {
    if (window.innerWidth < 768) {
      var mainCollectionFilters = document.getElementById(
        "main-collection-filters",
      );
      mainCollectionFilters.classList.remove("sidebar-sticky");
    }
  }
  // Call the function on page load
  removeClassIfLessThan768();
  // Add an event listener to adjust if the window size changes
  window.addEventListener("resize", removeClassIfLessThan768);
});
